import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/system",
    name: "系统管理",
    component: () => import("../views/System.vue"),
    redirect: "/system/defaultPage",
    children: [
      {
        path: "/system/review",
        name: "年度评价",
        component: () => import("../views/Review.vue"),

        children: [
          {
            path: "/system/review/reviewTasksList",
            name: "评价工作管理",
            component: () => import("../components/review/reviewTasksList.vue"),
          },
          {
            path: "/system/review/reviewTasksListCompanyAlt",
            name: "企业评价任务",
            component: () =>
              import("../components/review/reviewTasksListCompany.vue"),
          },
          {
            path: "/system/review/reviewTaskDetail",
            name: "评价工作-企业列表",
            component: () =>
              import("../components/review/reviewTaskDetail.vue"),
          },
          {
            path: "/system/review/reviewSubmit",
            name: "评价工作-评价填报",
            component: () => import("../components/review/reviewSubmit.vue"),
          },
          {
            path: "/system/review/reviewHistoryGZ",
            name: "评价历史记录",
            component: () =>
              import("../components/review/reviewHistoryGZCQ.vue"),
          },
          {
            path: "/system/review/reviewHistoryDetail",
            name: "评价历史记录——填报单",
            component: () =>
              import("../components/review/reviewHistoryDetail.vue"),
          },
          {
            path: "/system/review/reviewAppealAlt",
            name: "评价申诉",
            component: () => import("../components/review/reviewAppeal.vue"),
          },
          {
            path: "/system/review/auditHistoryCompany",
            name: "评价审核记录（企业）",
            component: () =>
              import("../components/review/auditHistoryCompany.vue"),
          },
        ],
      },
      {
        path: "/system/audition",
        name: "评价审核",
        component: () => import("../views/Audition.vue"),
        children: [
          {
            path: "/system/audition/auditionExport",
            name: "评价导出",
            component: () =>
              import("../components/audition/auditionExport.vue"),
          },
          {
            path: "/system/audition/auditionList",
            name: "审核列表",
            component: () => import("../components/audition/auditionList.vue"),
          },
          {
            path: "/system/audition/auditionDetail",
            name: "审核详情",
            component: () =>
              import("../components/audition/auditionDetail.vue"),
          },
          {
            path: "/system/audition/appealAudtionList",
            name: "申诉审核列表",
            component: () =>
              import("../components/audition/appealAudtionList.vue"),
          },
          {
            path: "/system/audition/auditionAppeal",
            name: "申诉审核",
            component: () =>
              import("../components/audition/auditionAppeal.vue"),
          },
          {
            path: "/system/audition/zyjReviewList",
            name: "往年评价记录",
            component: () => import("../components/audition/zyjReviewList.vue"),
          },
          {
            path: "/system/audition/zyjReviewListCo",
            name: "企业往年评价记录",
            component: () =>
              import("../components/audition/zyjReviewListCo.vue"),
          },
          {
            path: "/system/audition/zyjReviewDetail",
            name: "往年评价详情",
            component: () =>
              import("../components/audition/zyjReviewDetail.vue"),
          },
        ],
      },
      {
        path: "/system/misc",
        name: "misc",
        component: () => import("../views/Misc.vue"),
        children: [
          {
            path: "/system/misc/trainingVideoAdmin",
            name: "培训视频管理",
            component: () =>
              import("../components/misc/trainingVideoAdmin.vue"),
          },
          {
            path: "/system/misc/trainingVideoCompany",
            name: "企业培训视频",
            component: () =>
              import("../components/misc/trainingVideoCompany.vue"),
          },
        ],
      },
      {
        path: "/system/workTask",
        name: "评价任务",
        component: () => import("../views/WorkTask.vue"),
        children: [
          {
            path: "/system/workTask/indexPage",
            name: "评价工作任务",
            component: () => import("../components/worktask/indexPage.vue"),
          },
          {
            path: "/system/workTask/childrenPage",
            name: "评价工作详情",
            component: () => import("../components/worktask/childrenPage.vue"),
          },
        ],
      },
      // {
      //   path: "/system/evaluatetarget",
      //   name: "评价指标",
      //   component: () => import("../views/EvaluateTarget.vue"),
      //   children: [
      //     {
      //       path: "/system/evaluatetarget/indexPage",
      //       name: "评价指标大项",
      //       component: () =>
      //         import("../components/evaluatetarget/indexPage.vue"),
      //     },
      //     {
      //       path: "/system/evaluatetarget/childrenPage",
      //       name: "评价指标小项",
      //       component: () =>
      //         import("../components/evaluatetarget/childrenPage.vue"),
      //     },
      //   ],
      // },
      {
        path: "/system/defaultPage",
        name: "默认导航",
        component: () => import("../components/system/defaultPage.vue"),
      },
      {
        path: "/system/menu",
        name: "菜单管理",
        component: () => import("../components/system/menu.vue"),
      },
      {
        path: "/system/changePWD",
        name: "密码修改",
        component: () => import("../components/system/changePWD.vue"),
      },
      {
        path: "/system/roleTable",
        name: "角色管理",
        component: () => import("../components/role/roleTable.vue"),
      },
      {
        path: "/system/userRole",
        name: "用户角色",
        component: () => import("../components/role/userRole.vue"),
      },
      {
        path: "/system/userTable",
        name: "用户管理",
        component: () => import("../components/system/userTable.vue"),
      },
      {
        path: "/system/userTable/comInfo",
        name: "企业信息",
        component: () => import("../components/company/comInfo.vue"),
      },
      {
        path: "/system/userTable/companyList",
        name: "企业列表",
        component: () => import("../components/company/companyList.vue"),
      },
      {
        path: "/system/userTable/companyPassword",
        name: "查询企业密码",
        component: () => import("../components/company/companyPassword.vue"),
      },
      {
        path: "/system/roleUsersTable",
        name: "角色用户",
        component: () => import("../components/role/roleUsersTable.vue"),
      },  
      // {
      //   path: "/system/ImExportUser",
      //   name: "导入评价新用户",
      //   component: () => import("../components/system/ImExportUser.vue"),
      // },
      
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
